import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isIncluded',
    standalone: false
})
export class IsIncludedPipe implements PipeTransform {

    transform(value: any, array: any[]): boolean {
        return array.includes(value);
    }

}
